export const INDIA_GST_STATES = [
  { code: '01', name: 'Jammu & Kashmir' },
  { code: '02', name: 'Himachal Pradesh' },
  { code: '03', name: 'Punjab' },
  { code: '04', name: 'Chandigarh' },
  { code: '05', name: 'Uttarakhand' },
  { code: '06', name: 'Haryana' },
  { code: '07', name: 'Delhi' },
  { code: '08', name: 'Rajasthan' },
  { code: '09', name: 'Uttar Pradesh' },
  { code: '10', name: 'Bihar' },
  { code: '11', name: 'Sikkim' },
  { code: '12', name: 'Arunachal Pradesh' },
  { code: '13', name: 'Nagaland' },
  { code: '14', name: 'Manipur' },
  { code: '15', name: 'Mizoram' },
  { code: '16', name: 'Tripura' },
  { code: '17', name: 'Meghalaya' },
  { code: '18', name: 'Assam' },
  { code: '19', name: 'West Bengal' },
  { code: '20', name: 'Jharkhand' },
  { code: '21', name: 'Odisha' },
  { code: '22', name: 'Chhattisgarh' },
  { code: '23', name: 'Madhya Pradesh' },
  { code: '24', name: 'Gujarat' },
  { code: '26', name: 'Dadra and Nagar Haveli and Daman and Diu' },
  { code: '27', name: 'Maharashtra' },
  { code: '29', name: 'Karnataka' },
  { code: '30', name: 'Goa' },
  { code: '31', name: 'Lakshadweep' },
  { code: '32', name: 'Kerala' },
  { code: '33', name: 'Tamil Nadu' },
  { code: '34', name: 'Puducherry' },
  { code: '35', name: 'Andaman and Nicobar Islands' },
  { code: '36', name: 'Telangana' },
  { code: '37', name: 'Andhra Pradesh' },
  { code: '38', name: 'Ladakh' },
];

function normKey(value) {
  return String(value || '').replace(/\s+/g, '').toLowerCase();
}

export function findGstStateByName(name) {
  const key = normKey(name);
  if (!key) return null;
  return INDIA_GST_STATES.find((s) => normKey(s.name) === key) || null;
}

export function resolveGstStateSelection(stateCode, stateName) {
  if (stateCode) {
    const padded = String(stateCode).padStart(2, '0');
    const byCode = INDIA_GST_STATES.find((s) => s.code === padded);
    if (byCode) return byCode.code;
  }
  const byName = findGstStateByName(stateName);
  return byName?.code || '';
}

export function isBillingProfileComplete(profile) {
  if (!profile) return false;
  return Boolean(
    profile.legal_name?.trim()
    && profile.address_line1?.trim()
    && profile.city?.trim()
    && profile.state?.trim()
    && profile.pincode?.trim(),
  );
}
